import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlayForWorkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"play_for_work"}/>
}
